import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { SuggestionDiscountSettings } from "../../recommendation.types";

export const requestGetSuggestionDiscountSettings =
  async (): Promise<SuggestionDiscountSettings> => {
    return await instance.get(ApiRoutesRecommendation.SuggestionDiscount);
  };
